// extracted by mini-css-extract-plugin
export default {"IconContainerDash":"IconContainerDash_IconContainerDash__2UKoz"};